import { render } from "./VStrong.vue?vue&type=template&id=e04e2308&ts=true"
import script from "./VStrong.vue?vue&type=script&lang=ts"
export * from "./VStrong.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__